import { render, staticRenderFns } from "./account_management_details.vue?vue&type=template&id=617cb52c&scoped=true"
import script from "./account_management_details.vue?vue&type=script&lang=js"
export * from "./account_management_details.vue?vue&type=script&lang=js"
import style0 from "./account_management_details.vue?vue&type=style&index=0&id=617cb52c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617cb52c",
  null
  
)

export default component.exports